import { galleries } from './data/galleries';
import { initGallery } from './gallery';
import { initNav, initScrollAnimations } from './nav';

initNav();
initScrollAnimations();

const root = document.querySelector<HTMLElement>('[data-gallery]');
if (root) {
  const id = root.dataset.gallery ?? '';
  const config = galleries[id];
  if (!config) {
    console.error(`Gallery config not found: ${id}`);
  } else {
    const image = document.getElementById('galleryImage') as HTMLImageElement;
    const indicator = document.getElementById('pageIndicator') as HTMLElement;
    const prevBtn = document.getElementById('prevBtn') as HTMLButtonElement;
    const nextBtn = document.getElementById('nextBtn') as HTMLButtonElement;
    const thumbs = document.getElementById('thumbnails') as HTMLElement;
    const loading = document.getElementById('loading') as HTMLElement;
    const fullscreenBtn = document.getElementById('fullscreenBtn') as HTMLButtonElement | null;

    if (image && indicator && prevBtn && nextBtn && thumbs && loading) {
      initGallery(config, {
        image,
        indicator,
        prevBtn,
        nextBtn,
        thumbs,
        loading,
        fullscreenBtn,
        root,
      });
    }
  }
}
